import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { BotanicalDivider } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function Benefits() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 px-6 relative bg-cream" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-20" data-id="element-35">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-forest-dark mb-6 uppercase leading-tight" data-id="element-36">
            {t('benefits_section.title')}
          </h2>
          <div className="w-16 h-[1px] bg-gold mx-auto mb-10" data-id="element-37"></div>
          <p className="text-2xl font-serif text-forest/80 italic" data-id="element-38">
            {t('benefits_section.intro')}
          </p>
        </motion.div>

        <div className="bg-white/60 backdrop-blur-sm rounded-[3rem] p-10 md:p-16 shadow-soft border border-gold/20" data-id="element-39">
          <ul className="space-y-8" data-id="element-40">
            {t('benefits_section.items').map((item: string, index: number) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1 * index
          }} className="flex items-start gap-6" data-id="element-41">
                <div className="mt-1 p-2 rounded-full bg-gold/10 text-gold-dark flex-shrink-0" data-id="element-42">
                  <Sparkles className="w-6 h-6" data-id="element-43" />
                </div>
                <span className="text-xl text-forest/90 font-light leading-relaxed pt-1" data-id="element-44">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <BotanicalDivider data-id="element-45" />
      </div>
    </section>;
}